import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './nativeAdCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ProgressBarSetter from '../../services/progressBarSetter';
import WebFont from 'webfontloader';
import Rx from 'rx';
import copyContentModalTemplate from './copyContentModal.jade';

export class NativeAdCreativesFormController {
  /* @ngInject */
  constructor($scope, $element, $timeout, $window, currentGame, GamesResource, $stateParams, $filter, setProgressBar, ModalService, BannerPreviewResource, notify) {
    this.$scope = $scope;
    this.$window = $window;
    this.currentGame = currentGame;
    this.GamesResource = GamesResource;
    this.$stateParams = $stateParams;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.setProgressBar = setProgressBar;
    this.ModalService = ModalService;
    this.BannerPreviewResource = BannerPreviewResource;
    this.notify = notify;
    this.activeTextBlock = null;
    this.statusOptions = [
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];
    this.fallbackOptions = [
      {name: 'fallback', value: true},
      {name: 'fallback', value: false}
    ];

    if(!this.creative.id) {
      this.creative.active = true;
      this.creative.fallback = false;
    }

    $scope.$on('scrollToCreative', (event, creativeId) => {
      if (!this.creative || String(this.creative.id) !== String(creativeId)) return;
      $timeout(() => {
        const el = $element[0];
        el.classList.add('is-highlighted');
        $timeout(() => el.classList.remove('is-highlighted'), 2000);
        this.isEditingNativeBanner = true;
        $timeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
      }, 300);
    });
  }

  toggleExpand() {
    this.isEditingNativeBanner = !this.isEditingNativeBanner;
    if (this.isEditingNativeBanner) {
      this.updateUrlWithCreativeId();
    } else {
      this.removeCreativeIdFromUrl();
    }
  }

  buildDeepLink() {
    const variationId = this.variation && this.variation.id;
    if (!variationId || !this.creative.id) return null;
    const baseUrl = this.$window.location.href.replace(/#\d+(-\d+)?$/, '');
    return baseUrl + '#' + variationId + '-' + this.creative.id;
  }

  updateUrlWithCreativeId() {
    const deepLink = this.buildDeepLink();
    if (deepLink) {
      this.$window.history.replaceState(null, '', deepLink);
    }
  }

  removeCreativeIdFromUrl() {
    const cleanedUrl = this.$window.location.href.replace(/-\d+$/, '');
    this.$window.history.replaceState(null, '', cleanedUrl);
  }

  handleNewNativeAdIcon(newNativeAdIcon){
    this.isLoadingNativeAdIcon = true;
    if(newNativeAdIcon){
      this.$scope.$emit('newFileUploaded', newNativeAdIcon, this.creative, 'nativeAdIcon');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingNativeAdIcon = false);
    }
  }


  handleNewNativeAdMainImg(newNativeAdMainImg){
    this.isLoadingNativeAdMainImg = true;
    if(newNativeAdMainImg){
      this.$scope.$emit('newFileUploaded', newNativeAdMainImg, this.creative, 'nativeAdMainImg');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingNativeAdMainImg = false);
    }
  }

  removeCreative() {
    if (!this.creative.id) {
      let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
      if (indexOfCreativeToRemove > -1) {
        this.variation.creatives.splice(indexOfCreativeToRemove,1);
      }
    } else {
      this.creative.is_deleted = true;
      return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
          .then((creativeRes) => {
            let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
            if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
            }
          });
    }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }

  get nativeAdIconUrl() {
    return this.creative.icon_image_url || _.get(this.creative, 'nativeAdIcon.$ngfBlobUrl')
  }

  get nativeAdMainImgUrl() {
    return this.creative.main_image_url || _.get(this.creative, 'nativeAdMainImg.$ngfBlobUrl')
  }

  openAdIconPreview() {
    this.showPreviewModal(this.nativeAdIconUrl);
  }

  openAdMainImgPreview(){
    this.showPreviewModal(this.nativeAdMainImgUrl);
  }

  showPreviewModal(url){
    this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <img ng-src="{{vm.url | adaptNonCDNHttpsUrls}}" style='margin-top: 15px;'/>
            <svg gg-icon='icon-close' style='position: absolute;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.url = url;
        this.close = close;
      }
    });
  }

  isUACampaign() {
    return this.campaign.type == 'Acquisition';
  }

  isEngagementCampaign() {
    return this.campaign.type == 'Engagement';
  }

  setLineEditing(line) {
    this.creative.definition.lines.forEach((l) => l.editing = false);
    line.editing = true;
  }
}

let NativeAdCreativesFormComponent = {
  template: () => { return template },
  controller: NativeAdCreativesFormController,
  controllerAs: 'vm',
  bindings: {
    campaign: '=',
    creative: '=',
    variation: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.nativeAdCreativesForm', [
  'ngFileUpload',
  'app.services.progressBar',
  'angularModalService',
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name
])
  .component('nativeAdCreativesForm', NativeAdCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/nativeAdCreativesForm.js
 **/